// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--wua2r","container":"container--H13bH","content":"content--zhFqb","fadeSlideUp":"fadeSlideUp--hvUju"};